/*eslint complexity: ["error", 2]*/
import { match } from 'ts-pattern';
import authApi from '~/authApi';
import DocumentTitle from '~/components/DocumentTitle';
import { Error403 } from '~/components/Error403';
import { FoamSpinner } from '~/components/FoamSpinner';
import withAuthRequired from '~/components/withAuthRequired';
import { FEATURE_FLAGS, USER_ROLES } from '~/constants';
import { useFeature } from '~/hooks/useFeatureFlag/useFeature';
import { LoggedLayout } from '~/layouts/LoggedLayout';
import { CreatorMediaKits } from '~/screens/CreatorMediaKits/CreatorMediaKits';
import { AllShareables } from '~/screens/CustomShareablesListing/AllShareables';
import { DeleteMediaKitModal } from '~/screens/PageBuilder/modals/DeleteConfirmation/DeleteMediaKitModal';

const getPageVariant = (userIsManager: boolean) =>
  userIsManager ? undefined : 'restricted';
const getPageEmailNotification = (userIsManager: boolean) =>
  userIsManager ? undefined : false;
const getPageUserVariant = (userIsManager: boolean) =>
  userIsManager ? 'manager' : 'creator';

const CustomShareablesPage = () => {
  const { isEnabled, status } = useFeature(FEATURE_FLAGS.foamCustomShareable);

  const userIsManager = authApi.user.roles.includes(USER_ROLES.talentManager);

  if (status === 'loading') return <FoamSpinner />;

  return match(isEnabled)
    .with(true, () => (
      <LoggedLayout
        variant={getPageVariant(userIsManager)}
        showEmailNotVerifiedNotification={getPageEmailNotification(
          userIsManager,
        )}
        backgroundColor="neutral.50"
        userVariant={getPageUserVariant(userIsManager)}
      >
        <DocumentTitle>Media Kits</DocumentTitle>
        {match(userIsManager)
          .with(true, () => <AllShareables />)
          .with(false, () => <CreatorMediaKits />)
          .exhaustive()}

        <DeleteMediaKitModal />
      </LoggedLayout>
    ))
    .otherwise(() => <Error403 />);
};

export default withAuthRequired(CustomShareablesPage);
